import { createSelector } from "reselect";

import type { PointOfInterest } from "@app/types/napi-types";

import { getRoute } from "./state-accessors";

export const getPointsOfInterest = createSelector([getRoute], route =>
  route.points_of_interest
    ? route.points_of_interest.reduce<Record<string, PointOfInterest>>(
        (acc, poi) => {
          acc[poi.uuid] = poi;
          return acc;
        },
        {}
      )
    : {}
);
